import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var roundFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 18C12.2761 18 12.5 17.7761 12.5 17.5V10C12.5 9.72386 12.2761 9.5 12 9.5C11.7239 9.5 11.5 9.72386 11.5 10V17.5C11.5 17.7761 11.7239 18 12 18ZM13 7C13 6.44771 12.5523 6 12 6C11.4477 6 11 6.44771 11 7C11 7.55229 11.4477 8 12 8C12.5523 8 13 7.55229 13 7Z"
});
var roundLined = ___EmotionJSX(React.Fragment, null, ___EmotionJSX("path", {
  d: "M12 18C12.2761 18 12.5 17.7761 12.5 17.5V10C12.5 9.72386 12.2761 9.5 12 9.5C11.7239 9.5 11.5 9.72386 11.5 10V17.5C11.5 17.7761 11.7239 18 12 18Z"
}), ___EmotionJSX("path", {
  d: "M13 7C13 6.44771 12.5523 6 12 6C11.4477 6 11 6.44771 11 7C11 7.55229 11.4477 8 12 8C12.5523 8 13 7.55229 13 7Z"
}), ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
}));
var sharpFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.5 18V17.5V10V9.5H11.5V10V17.5V18H12.5ZM13 7C13 6.44771 12.5523 6 12 6C11.4477 6 11 6.44771 11 7C11 7.55229 11.4477 8 12 8C12.5523 8 13 7.55229 13 7Z"
});
var sharpLined = ___EmotionJSX(React.Fragment, null, ___EmotionJSX("path", {
  d: "M12.5 18V9.5H11.5V18H12.5Z"
}), ___EmotionJSX("path", {
  d: "M13 7C13 6.44771 12.5523 6 12 6C11.4477 6 11 6.44771 11 7C11 7.55229 11.4477 8 12 8C12.5523 8 13 7.55229 13 7Z"
}), ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
}));
var IconInfo = makeIcon('IconInfo', 'Info', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconInfo;